// UI translations for the app shell (NO / ES / EN / PL)
export const LANGS = [
  { code: "no", label: "Norsk" },
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "pl", label: "Polski" },
];

export const CATEGORIES = ["insult", "exclamation", "compound", "idiom"];

const dict = {
  brand_tagline: {
    no: "En offentlig ordbok over norske banneord",
    es: "Diccionario público de palabrotas noruegas",
    en: "A public dictionary of Norwegian swear words",
    pl: "Publiczny słownik norweskich przekleństw",
  },
  brand_tagline_es: {
    no: "En offentlig ordbok over spanske skjellsord",
    es: "Diccionario público de insultos españoles",
    en: "A public dictionary of Spanish insults",
    pl: "Publiczny słownik hiszpańskich wyzwisk",
  },
  source_label: { no: "Opphav", es: "Origen", en: "Source", pl: "Źródło" },
  age_modal_title: {
    no: "Innholdsadvarsel",
    es: "Aviso de contenido",
    en: "Content warning",
    pl: "Ostrzeżenie o treści",
  },
  age_modal_body: {
    no: "Dette nettstedet inneholder eksplisitt og vulgært språk. Du må være 18 år eller eldre for å fortsette.",
    es: "Este sitio contiene lenguaje explícito y vulgar. Debes ser mayor de 18 años para continuar.",
    en: "This site contains explicit and vulgar language. You must be 18+ to continue.",
    pl: "Ta strona zawiera wulgarny i obraźliwy język. Musisz mieć ukończone 18 lat, aby kontynuować.",
  },
  age_accept: { no: "Jeg er 18+ — gå inn", es: "Tengo 18 o más — entrar", en: "I'm 18+ — enter", pl: "Mam 18+ — wejdź" },
  age_leave: { no: "Forlat", es: "Salir", en: "Leave", pl: "Wyjdź" },
  nav_browse: { no: "Utforsk", es: "Explorar", en: "Browse", pl: "Przeglądaj" },
  nav_submit: { no: "Send inn ord", es: "Enviar palabra", en: "Submit a word", pl: "Zgłoś słowo" },
  nav_admin: { no: "Admin", es: "Admin", en: "Admin", pl: "Admin" },
  search_placeholder: {
    no: "Søk på norsk eller ditt språk…",
    es: "Buscar en noruego o en tu idioma…",
    en: "Search in Norwegian or your language…",
    pl: "Szukaj po norwesku lub w swoim języku…",
  },
  filter_category: { no: "Kategori", es: "Categoría", en: "Category", pl: "Kategoria" },
  filter_intensity: { no: "Intensitet", es: "Intensidad", en: "Intensity", pl: "Intensywność" },
  filter_lang: { no: "Oversettelsesspråk", es: "Idioma de traducción", en: "Translation language", pl: "Język tłumaczenia" },
  all: { no: "Alle", es: "Todas", en: "All", pl: "Wszystkie" },
  cat_insult: { no: "Fornærmelse", es: "Insulto", en: "Insult", pl: "Obelga" },
  cat_exclamation: { no: "Utrop", es: "Exclamación", en: "Exclamation", pl: "Wykrzyknik" },
  cat_compound: { no: "Sammensetning", es: "Compuesto", en: "Compound", pl: "Złożenie" },
  cat_idiom: { no: "Idiomatisk uttrykk", es: "Expresión idiomática", en: "Idiomatic expression", pl: "Wyrażenie idiomatyczne" },
  intensity_1: { no: "Mild", es: "Suave", en: "Mild", pl: "Łagodne" },
  intensity_5: { no: "Veldig sterk", es: "Muy fuerte", en: "Very strong", pl: "Bardzo mocne" },
  no_results: {
    no: "Ingen resultater. Prøv å fjerne filtre.",
    es: "Sin resultados. Prueba a quitar filtros.",
    en: "No results. Try clearing filters.",
    pl: "Brak wyników. Spróbuj wyczyścić filtry.",
  },
  votes: { no: "stemmer", es: "votos", en: "votes", pl: "głosów" },
  word_of_day: { no: "Dagens banneord", es: "Palabrota del día", en: "Swear of the day", pl: "Przekleństwo dnia" },
  load_more: { no: "Vis mer", es: "Ver más", en: "Load more", pl: "Pokaż więcej" },
  example_label: { no: "Eksempel", es: "Ejemplo", en: "Example", pl: "Przykład" },
  definition_label: { no: "Definisjon", es: "Definición", en: "Definition", pl: "Definicja" },
  region_label: { no: "Region", es: "Región", en: "Region", pl: "Region" },
  category_label: { no: "Kategori", es: "Categoría", en: "Category", pl: "Kategoria" },
  translations_label: { no: "Tilsvarende uttrykk", es: "Equivalentes", en: "Equivalents", pl: "Odpowiedniki" },
  intensity_label: { no: "Gjennomsnittlig intensitet", es: "Intensidad media", en: "Average intensity", pl: "Średnia intensywność" },
  vote_prompt: { no: "Stem på intensiteten", es: "Vota la intensidad", en: "Vote the intensity", pl: "Oceń intensywność" },
  vote_thanks: { no: "Stemme registrert", es: "Voto registrado", en: "Vote recorded", pl: "Głos zapisany" },
  back: { no: "Tilbake", es: "Volver", en: "Back", pl: "Wróć" },
  submit_title: { no: "Foreslå et ord", es: "Proponer una palabra", en: "Submit a word", pl: "Zgłoś słowo" },
  submit_subtitle: {
    no: "Ingen registrering. En admin vurderer det før publisering.",
    es: "Sin registro. Un admin la revisará antes de publicarla.",
    en: "No signup. An admin will review it before publishing.",
    pl: "Bez rejestracji. Admin sprawdzi przed publikacją.",
  },
  field_word: { no: "Norsk ord", es: "Palabra en noruego", en: "Norwegian word", pl: "Słowo po norwesku" },
  field_word_es: { no: "Spansk ord/uttrykk", es: "Palabra o expresión en español", en: "Spanish word/expression", pl: "Hiszpańskie słowo/wyrażenie" },
  field_category: { no: "Kategori", es: "Categoría", en: "Category", pl: "Kategoria" },
  field_region: { no: "Region (valgfritt)", es: "Región (opcional)", en: "Region (optional)", pl: "Region (opcjonalnie)" },
  field_definition: { no: "Definisjon", es: "Definición", en: "Definition", pl: "Definicja" },
  field_example: { no: "Eksempel i en setning", es: "Ejemplo en una frase", en: "Example in a sentence", pl: "Przykład w zdaniu" },
  submit_btn: { no: "Send inn til vurdering", es: "Enviar para revisión", en: "Submit for review", pl: "Wyślij do recenzji" },
  duplicate_word: {
    no: "Dette ordet finnes allerede i ordboken.",
    es: "Esta palabra ya existe en el diccionario.",
    en: "This word already exists in the dictionary.",
    pl: "To słowo już istnieje w słowniku.",
  },
  checking_word: { no: "Sjekker…", es: "Comprobando…", en: "Checking…", pl: "Sprawdzanie…" },
  submitting: { no: "Genererer AI-oversettelser…", es: "Generando traducciones IA…", en: "Generating AI translations…", pl: "Generowanie tłumaczeń AI…" },
  submit_success: {
    no: "Takk! Ordet ditt er til vurdering.",
    es: "¡Gracias! Tu palabra está en revisión.",
    en: "Thanks! Your word is under review.",
    pl: "Dzięki! Twoje słowo czeka na zatwierdzenie.",
  },
  ai_translation_note: {
    no: "Oversettelser genereres automatisk av AI (Claude) og gjennomgås av en admin.",
    es: "Las traducciones se generarán automáticamente con IA (Claude) y un admin las revisará.",
    en: "Translations will be auto-generated by AI (Claude) and reviewed by an admin.",
    pl: "Tłumaczenia są generowane przez AI (Claude) i sprawdzane przez admina.",
  },
  admin_login_title: { no: "Administratorpålogging", es: "Acceso de administrador", en: "Administrator login", pl: "Logowanie admina" },
  email: { no: "E-post", es: "Correo", en: "Email", pl: "Email" },
  password: { no: "Passord", es: "Contraseña", en: "Password", pl: "Hasło" },
  login: { no: "Logg inn", es: "Entrar", en: "Log in", pl: "Zaloguj" },
  logout: { no: "Logg ut", es: "Salir", en: "Log out", pl: "Wyloguj" },
  admin_queue: { no: "Modereringskø", es: "Cola de moderación", en: "Moderation queue", pl: "Kolejka moderacji" },
  pending: { no: "Venter", es: "Pendientes", en: "Pending", pl: "Oczekujące" },
  approved: { no: "Godkjent", es: "Aprobadas", en: "Approved", pl: "Zatwierdzone" },
  rejected: { no: "Avvist", es: "Rechazadas", en: "Rejected", pl: "Odrzucone" },
  approve: { no: "Godkjenn", es: "Aprobar", en: "Approve", pl: "Zatwierdź" },
  reject: { no: "Avvis", es: "Rechazar", en: "Reject", pl: "Odrzuć" },
  save: { no: "Lagre", es: "Guardar", en: "Save", pl: "Zapisz" },
  regenerate_ai: { no: "Regenerer med AI", es: "Regenerar con IA", en: "Regenerate with AI", pl: "Regeneruj z AI" },
  delete: { no: "Slett", es: "Eliminar", en: "Delete", pl: "Usuń" },
  total_words: { no: "ord", es: "palabras", en: "words", pl: "słów" },
  loading: { no: "Laster…", es: "Cargando…", en: "Loading…", pl: "Ładowanie…" },
  kofi_support: {
    no: "Spander en brunost på meg",
    es: "Invítame a un brunost",
    en: "Buy me a brunost",
    pl: "Postaw mi brunost",
  },
  add_word: { no: "Legg til ord", es: "Añadir palabra", en: "Add word", pl: "Dodaj słowo" },
  add_word_title: { no: "Legg til ord (publiser direkte)", es: "Añadir palabra (publicación directa)", en: "Add word (publish directly)", pl: "Dodaj słowo (publikacja bezpośrednia)" },
  source_lang: { no: "Kildespråk", es: "Idioma de origen", en: "Source language", pl: "Język źródłowy" },
  generate_ai: { no: "Generer med AI", es: "Generar con IA", en: "Generate with AI", pl: "Generuj z AI" },
  publish: { no: "Publiser", es: "Publicar", en: "Publish", pl: "Opublikuj" },
  cancel: { no: "Avbryt", es: "Cancelar", en: "Cancel", pl: "Anuluj" },
  region: { no: "Region", es: "Región", en: "Region", pl: "Region" },
  add_word_hint: {
    no: "Skriv ordet og definisjonen/eksempelet på kildespråket, generer med AI, gjennomgå og publiser.",
    es: "Escribe la palabra y su definición/ejemplo en el idioma de origen, genera con IA, revisa y publica.",
    en: "Enter the word and its definition/example in the source language, generate with AI, review and publish.",
    pl: "Wpisz słowo oraz definicję/przykład w języku źródłowym, wygeneruj z AI, sprawdź i opublikuj.",
  },
};

export function t(key, lang) {
  const entry = dict[key];
  if (!entry) return key;
  return entry[lang] || entry.en || key;
}

export function catLabel(cat, lang) {
  return t(`cat_${cat}`, lang);
}

// Region labels translated client-side from the canonical Spanish string
const REGION_DICT = {
  "Toda Noruega": { no: "Hele Norge", es: "Toda Noruega", en: "All of Norway", pl: "Cała Norwegia" },
  "Oslo / Este": { no: "Oslo / Øst", es: "Oslo / Este", en: "Oslo / East", pl: "Oslo / Wschód" },
  "Oslo": { no: "Oslo", es: "Oslo", en: "Oslo", pl: "Oslo" },
  "Bergen / Oeste": { no: "Bergen / Vest", es: "Bergen / Oeste", en: "Bergen / West", pl: "Bergen / Zachód" },
  "Trøndelag / Norte": { no: "Trøndelag / Nord", es: "Trøndelag / Norte", en: "Trøndelag / North", pl: "Trøndelag / Północ" },
  "Toda España": { no: "Hele Spania", es: "Toda España", en: "All of Spain", pl: "Cała Hiszpania" },
  "Madrid": { no: "Madrid", es: "Madrid", en: "Madrid", pl: "Madryt" },
  "Andalucía": { no: "Andalusia", es: "Andalucía", en: "Andalusia", pl: "Andaluzja" },
  "Cataluña": { no: "Catalonia", es: "Cataluña", en: "Catalonia", pl: "Katalonia" },
};

export function regionLabel(region, lang) {
  if (!region) return "";
  const entry = REGION_DICT[region];
  if (entry) return entry[lang] || entry.es || region;
  return region;
}
